import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {QuoteWrapper} from '../../models/quote/quote-wrapper';
import {Page} from '../../utils/page';
import {Employee} from '../../models/employee/employee.model';
import {CoreState} from 'src/app/core/store/reducers';
import {QuoteSummary} from '../../models/quote/quote-summary';
import {QuoteServiceService} from '../../quote-service/quote-service.service';
import {Store} from '@ngrx/store';
import {EppRouterService} from '../../router/epp-router.service';
import {TranslateService} from '@ngx-translate/core';
import {CommercialOfferPersonalisation} from '../../models/commercial-offer/commercial-offer-personalisation';
import {CustomerContractService} from '../../customer-contract/_services/customer-contract.service';
import {CmcProductManagerService} from '../../products/_services/cmc/cmc-product-manager.service';
import {QuoteManagerService} from './quote-manager.service';
import {RxdbQuoteRepository} from '../../rxdb/repositories/quotes/rxdb-quote.repository';
import {ProductManagerV2Service} from '../../products/_services/product-manager-v2.service';
import {OptionPricingItemMapper} from '../../models/quote/pricing-item/mapper/option-pricing-item.mapper';

@Injectable()
export class StandaloneQuoteManagerService extends QuoteManagerService {

    API_URL = '/apiQuoteManager/v1/';

    constructor(
        protected rxdbQuoteRepository: RxdbQuoteRepository,
        protected http: HttpClient,
        protected eppRouterService: EppRouterService,
        protected quoteServiceService: QuoteServiceService,
        protected store: Store<CoreState>,
        protected translateService: TranslateService,
        protected customerContractService: CustomerContractService,
        protected productManagerV2Service: ProductManagerV2Service,
        protected cmcProductManagerService: CmcProductManagerService,
        protected optionPricingItemMapper: OptionPricingItemMapper ) {
        super(eppRouterService, quoteServiceService, store, translateService, customerContractService, productManagerV2Service, cmcProductManagerService, optionPricingItemMapper);
    }

    uploadQuote(wrapper: QuoteWrapper, employee: Employee, personalization?: CommercialOfferPersonalisation): Observable<any> {
        const serializedWrapper = QuoteManagerService.quoteWrapperToJSON(wrapper, employee) as any;
    
        serializedWrapper.isSynchronized = false;
        serializedWrapper.personalization = personalization ? JSON.parse(JSON.stringify(personalization)) : null;
        return from(this.rxdbQuoteRepository.saveQuote(serializedWrapper));
    }

    findQuoteById(quoteId: string): Observable<QuoteWrapper> {
        return from(this.rxdbQuoteRepository.getQuoteById(quoteId));
    }

    findQuotesSummary(employeeNumber: string, role: string, filters: Map<string, string>, sort: string, sortDirection: string, pageSize: number, pageIndex: number): Observable<Page<QuoteSummary>> {
        let params = new HttpParams();
        params = params.set('employeeNumber', employeeNumber);
        params = params.set('role', role);
        filters.forEach((value, key) => params = params.set(key, value));
        if (sort && sortDirection) {
            params = params.set('sort', sort + ',' + sortDirection);
        }
        params = params.set('page', pageIndex.toString());
        params = params.set('size', pageSize.toString());

        return this.http.get<Page<QuoteSummary>>(this.API_URL + 'quotes', {params});
    }

    updateStatus(status: string, quoteIds: string[]) {
        const data = {};
        data[status] = quoteIds;
        return this.http.post(this.API_URL + 'quotes/updateStatus', data);
    }

    sendPdf(quoteId: string, commercialOfferPersonalisation: CommercialOfferPersonalisation): Observable<any> {
        return this.http.post(this.API_URL + `quotes/generate-report/${quoteId}`, commercialOfferPersonalisation,
            { observe: 'response', responseType: 'blob' });
    }

}
